import { Crown, Radio } from "lucide-react";

export function FoundingBadge({ user, testId }) {
  if (!user?.founding_creator) return null;
  return (
    <span data-testid={testId} title="Founding Creator · one of the first 300"
      className="inline-flex items-center gap-1 text-[9px] uppercase tracking-[0.14em] text-gold border border-gold/50 bg-gold/10 px-1.5 py-0.5 rounded-full shrink-0">
      <Crown size={10} className="fill-gold/30" /> Founding Creator
    </span>
  );
}

export function StreamingOnlyLabel({ user, testId }) {
  if (!user?.is_creator) return null;
  return (
    <span data-testid={testId}
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] px-2.5 py-1 rounded-full border border-wine/60 bg-wine/30 text-text-main">
      <Radio size={11} /> Streaming only
    </span>
  );
}
